module.exports = __webpack_public_path__ + "downloads/null.78fa668c.xlsx";